<template>
    <el-dialog
        class="add-ioss"
        :visible.sync="addVisible"
        :close-on-click-modal="false"
        @closed="closeDialog"
        width="500px"
        title="Add IOSS"
        :lock-scroll="false"
        :modal-append-to-body="false"
        append-to-body
    >
        <div class="container">
            <el-form ref="addForm" :model="addForm" :rules="rules" label-width="60px" @keydown.enter.native.prevent>
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="Name" prop="name" size="small">
                            <el-input v-model="addForm.name" placeholder="Please input name"></el-input>
                        </el-form-item>
                        <el-form-item label="IOSS" prop="ioss" size="small">
                            <el-input v-model="addForm.ioss" placeholder="Please input ioss"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button size="small" type="primary" @click="save"
                >Save</el-button
            >
            <el-button size="small" @click="addVisible = false"
                >Close</el-button
            >
        </span>
    </el-dialog>
</template>

<script>
import { cmofferApi } from "@/http/cmofferApi.js";
export default {
    data() {
        return {
            addForm: {
                name: "",
                ioss: "",
            },
            rules: {
                name: [
                    {
                        required: true,
                        message: "Please input name",
                    },
                ],
                ioss: [
                    {
                        required: true,
                        message: "Please input ioss",
                    },
                ],
            },
        };
    },
    methods: {
        closeDialog() {
            this.$refs["addForm"].clearValidate();
            this.$refs["addForm"].resetFields();
            this.$emit("update:addVisible", false);
        },
        save() {
            this.$refs["addForm"].validate((valid) => {
                if (valid) {
                    cmofferApi
                        .iossList(
                            {
                                ...this.addForm,
                            },
                            "post"
                        )
                        .then((res) => {
                            if (res) {
                                this.$message.success(
                                    this.$i18n.locale == "zh"
                                        ? "新增成功"
                                        : "Success"
                                );
                                this.$parent[this.funcName] &&
                                    this.$parent[this.funcName]();
                                this.closeDialog();
                            }
                        });
                }
            });
        },
    },
    props: {
        addVisible: Boolean,
        funcName: String,
    },
    watch: {
        addVisible(val) {

        },
    },
};
</script>
<style lang="scss" scoped>
.add-ioss {
    .container {
        .el-select--small {
            width: 100%;
        }
    }
}
</style>
